jQuery_T4NT(document).ready(function($) {
     if (window.liftyCustomEnhancementsLoaded) {
       return;
     }

     window.liftyCustomEnhancementsLoaded = true;

     var liftyHummRefreshTimer = null;
     var liftyHummMinimumAmount = 66000;

     function liftyParseHummMoneyToCents(value) {
       var normalised = String(value || '').replace(/\s/g, '').replace(/[^\d.,-]/g, '');

       if (!normalised) {
         return NaN;
       }

       if (normalised.lastIndexOf(',') > normalised.lastIndexOf('.')) {
         normalised = normalised.replace(/\./g, '').replace(',', '.');
       } else {
         normalised = normalised.replace(/,/g, '');
       }

       var amount = Number(normalised);

       return Number.isFinite(amount) ? Math.round(amount * 100) : NaN;
     }

     function liftyGetHummCardWidgetAmount(widget) {
       var script = widget.querySelector('script[src*="flexifi-widget.js"][src*="productPrice"]');
       var match = script && script.getAttribute('src') ? script.getAttribute('src').match(/[?&]productPrice=([^&#]+)/) : null;

       return match ? liftyParseHummMoneyToCents(decodeURIComponent(match[1])) : NaN;
     }

     function liftySetHummWidgetVisibility(widget, isEligible) {
       widget.hidden = !isEligible;
       widget.setAttribute('aria-hidden', isEligible ? 'false' : 'true');
       widget.setAttribute('data-lifty-humm-eligible', isEligible ? 'true' : 'false');
     }

     function liftyApplyHummCardThreshold(widget) {
       var amount = liftyGetHummCardWidgetAmount(widget);
       var isEligible = !Number.isFinite(amount) || amount >= liftyHummMinimumAmount;

       liftySetHummWidgetVisibility(widget, isEligible);

       return isEligible;
     }

     function liftyApplyHummProductThreshold(priceCents) {
       document.querySelectorAll('[data-lifty-humm-widget]').forEach(function(widget) {
         var threshold = Number(widget.getAttribute('data-lifty-humm-minimum-amount') || liftyHummMinimumAmount);
         liftySetHummWidgetVisibility(widget, Number(priceCents) >= threshold);
       });
     }

     function liftyHasRenderedHummWidget(widget) {
       var renderedWidget = widget.querySelector('a#flexifi-tag .flexifi-main, a.flexifi-widget .flexifi-main');
       return !!(renderedWidget && renderedWidget.textContent.trim());
     }

     function liftyRefreshHummCardWidgets(root) {
       var scope = root && root.querySelectorAll ? root : document;
       var widgets = [];

       if (scope.matches && scope.matches('.flexifi-widget')) {
         widgets.push(scope);
       }

       scope.querySelectorAll('.flexifi-widget').forEach(function(widget) {
         widgets.push(widget);
       });

       widgets.forEach(function(widget) {
         if (!liftyApplyHummCardThreshold(widget)) {
           return;
         }

         var script = widget.querySelector('script[src*="flexifi-widget.js"][src*="productPrice"]');

         if (!script || liftyHasRenderedHummWidget(widget)) {
           return;
         }

         if (widget.getAttribute('data-lifty-humm-refreshing') === 'true') {
           return;
         }

         var attempts = Number(widget.getAttribute('data-lifty-humm-refresh-count') || 0);
         if (attempts >= 3) {
           return;
         }

         widget.setAttribute('data-lifty-humm-refresh-count', attempts + 1);
         widget.setAttribute('data-lifty-humm-refreshing', 'true');

         widget.querySelectorAll('a#flexifi-tag').forEach(function(link) {
           if (!link.textContent.trim()) {
             link.remove();
           }
         });

         var retryScript = document.createElement('script');
         retryScript.src = script.getAttribute('src');
         retryScript.async = true;
         retryScript.setAttribute('data-lifty-humm-retry', 'true');

         var finishRetry = function() {
           widget.removeAttribute('data-lifty-humm-refreshing');
           setTimeout(function() {
             retryScript.remove();
           }, 1000);
         };

         retryScript.addEventListener('load', finishRetry);
         retryScript.addEventListener('error', finishRetry);
         window.setTimeout(finishRetry, 5000);

         script.insertAdjacentElement('afterend', retryScript);
       });
     }

     function liftyScheduleHummRefresh(root) {
       if (liftyHummRefreshTimer) {
         window.clearTimeout(liftyHummRefreshTimer);
       }

       liftyHummRefreshTimer = window.setTimeout(function() {
         liftyRefreshHummCardWidgets(root || document);
       }, 300);
     }

     liftyScheduleHummRefresh(document);
     window.setTimeout(function() {
       liftyRefreshHummCardWidgets(document);
     }, 1800);
     window.setTimeout(function() {
       liftyRefreshHummCardWidgets(document);
     }, 4200);

     window.addEventListener('load', function() {
       liftyScheduleHummRefresh(document);
     });

     document.addEventListener('shopify:section:load', function(event) {
       liftyScheduleHummRefresh(event.target);
     });

     function liftyBuildFooterRepairNest(root) {
       var scope = root && root.querySelectorAll ? root : document;
       var footer = scope.matches && scope.matches('#t4s-footer') ? scope : scope.querySelector('#t4s-footer');

       if (!footer) {
         footer = document.querySelector('#t4s-footer');
       }

       if (!footer) {
         return;
       }

       Array.prototype.forEach.call(footer.querySelectorAll('.t4s-col-inner'), function(column) {
         if (column.hasAttribute('data-lifty-repair-nest')) {
           return;
         }

         var headings = column.querySelectorAll('.t4s-footer-heading .t4s-col-heading');
         var isRepairColumn = Array.prototype.some.call(headings, function(heading) {
           return heading.textContent.trim().toLowerCase() === 'repair specialists';
         });
         var content = column.querySelector('[data-footer-content]');

         if (!isRepairColumn || !content) {
           return;
         }

         column.setAttribute('data-lifty-repair-nest', 'true');
         column.classList.add('lifty-footer-repairs');
         content.id = content.id || 'lifty-footer-repair-links';
         content.hidden = false;
         content.removeAttribute('hidden');

         Array.prototype.forEach.call(column.querySelectorAll('.t4s-footer-heading'), function(heading) {
           heading.remove();
         });

         var nest = document.createElement('div');
         nest.className = 'lifty-footer-repairs__details';

         var toggle = document.createElement('div');
         toggle.className = 'lifty-footer-repairs__toggle';
         toggle.innerHTML = '<span>Repair Specialists</span><span class="lifty-footer-repairs__icon" aria-hidden="true"></span>';

         nest.appendChild(toggle);
         nest.appendChild(content);
         column.appendChild(nest);
       });
     }

     liftyBuildFooterRepairNest(document);

     function liftyNormaliseLabels(root) {
       var scope = root && root.querySelectorAll ? root : document;
       var selector = '[class*="badge"], [class*="label"], [class*="tag"], [class*="status"], [data-product-badge] > *, [data-product-single-badge] > *';

       Array.prototype.forEach.call(scope.querySelectorAll(selector), function(label) {
         if (label.closest('.lifty-whatsapp, [class*="payment"], [class*="klarna"], [class*="humm"], [class*="flexifi"], .shopify-payment-button')) {
           return;
         }

         var colour = window.getComputedStyle(label).backgroundColor;
         var match = colour && colour.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);

         if (!match) {
           return;
         }

         var red = Number(match[1]);
         var green = Number(match[2]);
         var blue = Number(match[3]);
         var maximum = Math.max(red, green, blue);
         var minimum = Math.min(red, green, blue);
         var isSaturated = maximum > 105 && maximum - minimum > 48;

         if (isSaturated) {
           label.classList.add('lifty-racing-colour-lock');
         }
       });
     }

     liftyNormaliseLabels(document);

     document.addEventListener('shopify:section:load', function(event) {
       liftyBuildFooterRepairNest(event.target);
       liftyNormaliseLabels(event.target);
     });

     $(document).on('facets:loaded currency:update ajaxComplete t4s:hideTooltip modalt4s:opened', function() {
       liftyScheduleHummRefresh(document);
       liftyNormaliseLabels(document);
     });

     if ('MutationObserver' in window && document.body) {
       var liftyHummObserver = new MutationObserver(function(mutations) {
         var shouldRefresh = Array.prototype.some.call(mutations, function(mutation) {
           return Array.prototype.some.call(mutation.addedNodes, function(node) {
             return node.nodeType === 1 && (
               node.matches('.flexifi-widget') ||
               node.querySelector('script[src*="flexifi-widget.js"]')
             );
           });
         });

         if (shouldRefresh) {
           liftyScheduleHummRefresh(document);
         }
       });

       liftyHummObserver.observe(document.body, {
         childList: true,
         subtree: true
       });
     }

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
       if ( evt.currentVariant && typeof evt.currentVariant.price !== 'undefined' ) {
         document.querySelectorAll('[data-lifty-klarna-placement] klarna-placement').forEach(function( placement ) {
           placement.setAttribute('data-purchase-amount', evt.currentVariant.price);
         });

         window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
         if ( typeof window.KlarnaOnsiteService.push === 'function' ) {
           window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
         }

         document.querySelectorAll('[data-lifty-humm-price]').forEach(function( price ) {
           price.textContent = ( evt.currentVariant.price / 100 ).toFixed(2);
         });

         liftyApplyHummProductThreshold(evt.currentVariant.price);
       }
	   });

});

